// adding .last property to all arrays
if (!Array.prototype.hasOwnProperty('last')) {
  Object.defineProperty(Array.prototype, 'last', {
    get: function() { return this[this.length - 1] },
    set: function(value) { this[this.length-1] = value } ,
  })
}
